import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "8", r: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Award";
const Award = memo(themed(Icon));
export {
  Award
};
//# sourceMappingURL=award.js.map
